<template>
    <rkm-form ref="Form">
        <rkm-row>
            <rkm-col>
                <rkm-form-checkbox
                    v-model="data.model.informaMovimentacoes"
                >
                    Informar movimentações para o web service
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.usuario"
                    label="Usuário"
                    v-model="data.model.usuario"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.senha"
                    @change="data.form.confirmarSenha = null"
                    label="Senha"
                    type="password"
                    v-model="data.model.senha"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="!data.model.senha"
                    :validations="validations.confirmarSenha"
                    label="Confirmar senha"
                    type="password"
                    v-model="data.form.confirmarSenha"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                usuario: { required: this.data.model.informaMovimentacoes, max: 180 },
                senha: { required: this.data.model.informaMovimentacoes, max: 100 },
                confirmarSenha: { required: this.data.model.senha, is: this.data.model.senha, max: 100 },
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>